import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  Typography,
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Checkbox,
  DialogTitle,
  IconButton,
} from "@mui/material";
import {
  Person as PersonIcon,
  SmartToy as SmartToyIcon,
  Close as CloseIcon
} from "@mui/icons-material";
import { green } from "@mui/material/colors";
import { headers, oauthUserMgmt, tenant } from "../../utils/utils";

const Invite = ({ ticketJsonData, setTicketJsonData }) => {
  const [memberList, setMemberList] = useState([]);
  const [selectedMembers, setSelectedMembers] = useState(
    ticketJsonData.members || [],
  );
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  useEffect(() => {
    fetchAllMembers();
  }, []);

  useEffect(() => {
    if (ticketJsonData.members) {
      setSelectedMembers(ticketJsonData.members);
    }
  }, [ticketJsonData.members]);
  
  
  const fetchAllMembers = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_USER_MGMT}/admin/realms/eVyoog/users?q=tenant:${tenant()}`,
        {
          method: "GET",
          headers: oauthUserMgmt(),
        },
      );

      if (response.ok) {
        const result = await response.json();
        const formattedMembers = result
          .filter((user) => user.firstName)
          .map((user) => ({
            id: user.id,
            fullName: `${user.firstName} ${user.lastName || ""}`,
          }));
        setMemberList(formattedMembers);
      } else {
        console.error("Failed to fetch members:", response.status);
      }
    } catch (error) {
      console.error("Error fetching members:", error);
    }
  };

  const handleToggleMember = (memberId) => {
    console.log("BEFORE TOGGLE isDialogOpen:", isDialogOpen);
    const updatedMembers = selectedMembers.includes(memberId)
      ? selectedMembers.filter((id) => id !== memberId)
      : [...selectedMembers, memberId];
      console.log("after TOGGLE isDialogOpen:", isDialogOpen);

    setSelectedMembers(updatedMembers);
    console.log("set TOGGLE isDialogOpen:", isDialogOpen);

    updateInviteMembers(updatedMembers);
    console.log("set TOGGLE isDialogOpen:", isDialogOpen);

   
  };

  const updateInviteMembers = async (updatedMembers) => {
    console.log("updateInviteMembers called, isDialogOpen:", isDialogOpen);
    try {
      const updatedData = { ...ticketJsonData, members: updatedMembers };
      const response = await fetch(
        `${process.env.REACT_APP_TICKET_SERVER}/ticket/workFlowUpdate?board=${localStorage.getItem("board")}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...headers(),
          },
          body: JSON.stringify(updatedData),
        },
      );

      if (response.ok) {
        console.log("set55 TOGGLE isDialogOpen:", isDialogOpen);

        setTicketJsonData(updatedData);
        console.log("set44 TOGGLE isDialogOpen:", isDialogOpen);

        console.log("Successfully updated members.");
        setIsDialogOpen(true)
      } else {
        console.error("Failed to update members:", response.status);
      }
    } catch (error) {
      console.error("Error updating members:", error);
    }
  };

  const dialogStyles = {
    height: "2px",
    background: "linear-gradient(90deg, #3f51b5, #ff5722)",
    margin: "12px 0 20px",
    borderRadius: "4px",
  };

  return (
    <>
      <div
        style={{
          padding: "20px",

          margin: "auto",
          background: "#f9f9f9",
          borderRadius: "8px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "16px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <PersonIcon
              style={{ fontSize: "28px", color: "#3f51b5", marginRight: "8px" }}
            />
          </div>
          <SmartToyIcon
            style={{ fontSize: "32px", color: "#ff5722", opacity: 0.8 }}
          />
        </div>
        <div style={dialogStyles}></div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "16px",
          }}
        >
          {selectedMembers.map((id) => {
            const member = memberList.find((m) => m.id === id);
            return (
              <div
                key={id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "8px 12px",
                  background: "#e3f2fd",
                  borderRadius: "8px",
                  border: "1px solid #bbdefb",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                }}
              >
                <Avatar
                  sx={{
                    width: 36,
                    height: 36,
                    fontSize: "12px",
                    backgroundColor: "#3f51b5",
                    color: "white",
                    marginRight: "12px",
                  }}
                >
                  {member ? member.fullName.charAt(0).toUpperCase() : "?"}
                </Avatar>
                <Typography
                  variant="body1"
                  style={{ fontWeight: 500, color: "#333" }}
                >
                  {member ? member.fullName : "Unknown"}
                </Typography>
              </div>
            );
          })}

          <Button
            variant="contained"
            startIcon={<PersonIcon />}
            style={{
              height: 50,
              backgroundColor: green[500],
              color: "white",
              fontWeight: "bold",
            }}
            onClick={() => setIsDialogOpen(true)}
          >
            Add Members
          </Button>
        </div>

        <Dialog
  open={isDialogOpen}
  onClose={(event, reason) => {
    console.log("Dialog onClose reason:", reason);
    if (reason === "backdropClick" || reason === "escapeKeyDown") return;
    setIsDialogOpen(false);
  }}
  
  
  fullWidth
>
<DialogTitle
  sx={{
    m: 0,
    p: 2,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  }}
>
  <Typography variant="h6" component="span">Select Members</Typography>
  <IconButton
    aria-label="close"
    onClick={() => setIsDialogOpen(false)}
    sx={{
      color: (theme) => theme.palette.grey[500],
    }}
  >
    <CloseIcon />
  </IconButton>
</DialogTitle>


  <DialogContent>
    <List>
  {memberList.map((member) => (                           
    <ListItem 
      key={member.id} 
      dense
      disablePadding
      // Make sure this is not treated as a button or selectable item
      component="div" 
    >
      <ListItemAvatar>
        <Avatar>{member.fullName.charAt(0).toUpperCase()}</Avatar>
      </ListItemAvatar>
      <ListItemText primary={member.fullName} />
      <Checkbox
        checked={selectedMembers.includes(member.id)}
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
        onChange={() => handleToggleMember(member.id)}
      />
    </ListItem>
  ))}
</List>

  </DialogContent>
</Dialog>

      </div>                                                                                            
    </>
  );
};

export default Invite;
